<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
const defaultLayout = "none";
export default {
  name: "App",
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    }
  }
};
</script>
